module.exports = __webpack_public_path__ + "static/media/performanceemail.af900d15.png";